export const iconFontAwesomeTransportationWheelchair = (
	<i className="fa-solid fa-wheelchair"></i>
);
